import { Box, Stack, Typography } from "@mui/material"
import Section from "./Section"

interface PartnerBoxProps {
  img: string
  link: string
}
function PartnerBox({ img, link }: PartnerBoxProps) {
  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <a href={link}>
        <Box component="img" src={img} width="160px" sx={{}} />{" "}
      </a>
    </Stack>
  )
}
export interface PartnersProps {
  phone: boolean
}

export default function Partners({ phone }: PartnersProps) {
  return (
    <Section>
      <Stack sx={{ width: "100%" }} alignItems="start" spacing={2}>
        <Typography fontWeight="bold" fontSize={34} sx={{ p: 1 }}>
          Partenaires
        </Typography>
        <Stack width="100%" sx={{ background: "#ffffff88" }}>
          <Stack
            sx={{ p: 2 }}
            spacing={8}
            direction={phone ? "column" : "row"}
            alignItems="center"
          >
            <PartnerBox
              img="/LVMH_LMDS.svg"
              link="https://lamaisondesstartups.lvmh.com/"
            />
            <PartnerBox img="/Station F.png" link="https://stationf.co/" />
            <PartnerBox img="/HFI.jpg" link="https://www.hub-franceia.fr/" />
          </Stack>
        </Stack>
      </Stack>
    </Section>
  )
}
